import type { Consultant } from '../types/content';

/*
 * Consultant directory. Update biographies, expertise, and portraits here.
 * Set `biographyConfirmed: true` once an approved biography replaces the placeholder introduction.
 * `expertise` should only list areas confirmed by the firm — leave empty until provided.
 */
export const consultants: Consultant[] = [
  {
    slug: 'moshood-a',
    name: 'Moshood A.',
    firstName: 'Moshood',
    initials: 'MA',
    title: 'Executive Search Consultant',
    email: 'moshood.exec.search.consultant@gmail.com',
    introduction:
      'Moshood is an Executive Search Consultant with Aurevane Search Partners. An approved professional biography will be published here once confirmed by the firm.',
    biographyConfirmed: false,
    expertise: [],
    tone: 'aubergine',
  },
  {
    slug: 'samuel-a',
    name: 'Samuel A.',
    firstName: 'Samuel',
    initials: 'SA',
    title: 'Executive Search Consultant',
    email: 'samuel.a.exec.search@gmail.com',
    introduction:
      'Samuel is an Executive Search Consultant with Aurevane Search Partners. An approved professional biography will be published here once confirmed by the firm.',
    biographyConfirmed: false,
    expertise: [],
    tone: 'copper',
  },
  {
    slug: 'michael-i',
    name: 'Michael I.',
    firstName: 'Michael',
    initials: 'MI',
    title: 'Executive Search Consultant',
    email: 'michael.exec.search.consultant@gmail.com',
    introduction:
      'Michael is an Executive Search Consultant with Aurevane Search Partners. An approved professional biography will be published here once confirmed by the firm.',
    biographyConfirmed: false,
    expertise: [],
    tone: 'sage',
  },
  {
    slug: 'anne-precious',
    name: 'Anne Precious',
    firstName: 'Anne',
    initials: 'AP',
    title: 'Executive Search Consultant',
    email: 'anne.p.exec.search.consultant@gmail.com',
    introduction:
      'Anne is an Executive Search Consultant with Aurevane Search Partners. An approved professional biography will be published here once confirmed by the firm.',
    biographyConfirmed: false,
    expertise: [],
    tone: 'plum',
  },
];

export const searchApproach = [
  'Begin every engagement by understanding the organization’s strategy, culture, and what the role must achieve.',
  'Engage experienced professionals discreetly, sharing information only as appropriate at each stage.',
  'Assess experience and suitability thoughtfully, looking beyond titles to judgment and leadership style.',
  'Communicate clearly and consistently with both clients and candidates throughout the search.',
];
